
import { defineComponent } from "@vue/runtime-core";
import * as TaskManager from "@/firebase/TaskManager";
import Task from "@/model/Task";
import Store from "@/model/Store";
import TraceabilityResultRow from "./TraceabilityResultRow.vue";
import * as Lang from "@/i18n/lang";
import TaskStatus from "../TaskStatus.vue";
import TaskWithResult from "@/pinia/tasks/TaskWithResult";
import * as DateUtils from "@/utils/DateUtils";

export default defineComponent({
  props: {
    taskWrapper: {
      type: TaskWithResult,
      required: true,
    },
    store: {
      type: Store,
    },
  },

  methods: {},
  async setup(props) {},
  data() {
    return {
      Lang: Lang,
      TaskManager: TaskManager,
      DateUtils: DateUtils,
    };
  },
  components: {
    TaskStatus,
    TraceabilityResultRow,
  },
});
